import React, { useRef } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getDashboard } from 'src/redux/dashboard/selectors';
import SelectStatisticDataModal from 'src/components/modals/SelectStatisticDataModal/SelectStatisticDataModal';
import { useOutsideClick } from 'src/hooks/utils';
import styles from './HeaderItem.module.scss';
import KPINumber from '../KPINumber/KPINumber';
import Icon from '../Icon/Icon';

export interface HeaderItemProps {
  title: string;
  description?: string;
  kpiNumber?: string;
  caption?: string;
  percentage?: number;
  information?: string;
  onSelect?: (index: string) => void;
  keyValues?: { key: React.ReactNode; value: React.ReactNode }[];
  isStatistic?: boolean;
  progressColor?: string;
}

const HeaderItem: React.FC<HeaderItemProps> = ({
  title,
  description,
  kpiNumber,
  caption,
  percentage,
  information,
  onSelect,
  isStatistic,
  keyValues,
  progressColor,
}) => {
  const dashboardState = useSelector(getDashboard);
  const modalRef = useRef<HTMLDivElement>(null);

  const [openModal, setOpenModal] = React.useState(false);

  const statisticTypes = [
    { statisticType: 'Sendungen' },
    { statisticType: 'Produkteingang' },
    { statisticType: 'Fälle' },
    { statisticType: 'Fälle %' },
    { statisticType: 'Destinationen' },
    { statisticType: 'Retouren' },
    { statisticType: 'Retouren %' },
  ];

  function handleClickOutside(event: MouseEvent) {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      setOpenModal(false);
    }
  }
  // register click outside event to close the menu
  useOutsideClick(modalRef, handleClickOutside);

  return (
    <div className={classNames(styles.root, 'flex flex-col p-20 min-h-[160px] gap-10')}>
      <div className={classNames(styles.title, 'relative')}>
        <div className="flex flex-col mb-20 gap-y-4">
          <h2 className="typo-text-16--bold font-semibold text-left">{title}</h2>
          {description && <span className="typo-text-12 text-faded">{description}</span>}
        </div>
        {dashboardState.isAdjusting && (
          <button onClick={() => setOpenModal(true)} type="button" aria-label="Adjust" className={styles.editButton}>
            <Icon name="edit" width={20} height={20} className="text-full opacity-60" />
          </button>
        )}
      </div>
      {kpiNumber !== undefined && (
        <KPINumber
          value={kpiNumber}
          label={caption}
          percentage={percentage}
          progressColor={progressColor}
          isStatistic={isStatistic}
        />
      )}
      {information && <span className="pt-16 typo-text-12 text-faded">{information}</span>}
      {keyValues && keyValues.length > 0 && (
        <ul>
          {keyValues.map(({ key, value }) => (
            <li key={key as string} className="flex justify-between">
              <span className="typo-text-12 text-faded">{key}</span>
              <span className="typo-text-12 font-semibold">{value}</span>
            </li>
          ))}
        </ul>
      )}

      {dashboardState.isAdjusting && openModal && (
        <div className="surface-elevated z-10 absolute" ref={modalRef}>
          <SelectStatisticDataModal
            isOpen
            onClose={() => console.log('close')}
            onItemSelect={onSelect}
            listItems={statisticTypes}
          />
        </div>
      )}
    </div>
  );
};

export default HeaderItem;
